<template>
<div class="schedule-bottom">
	<div class="row">
		<div class="col-md-6 my-auto agileinfo_schedule_bottom_left">
			<img src="https://radap.ir/imagesUploaded/main/mid.jpg" alt=" " class="img-responsive" />
		</div>
		<div class="col-md-6 agileits_schedule_bottom_right">
			<div class="w3ls_schedule_bottom_right_grid dir-rtl py-auto" style="border-radius:5px">
				<h3 class="text-center">تا<span> 50% </span>تخفیف بگیرید</h3>
				<p style="font-size: 14px;letter-spacing:0" class="text-center">تخفیف های استثنایی در آخرین روز هر ماه</p>
				<div class="row">
					<div class="col-md-6 w3l_schedule_bottom_right_grid1">
						<i class="fa fa-user" aria-hidden="true"></i>
						<h4>خانواده راداپ</h4>
						<h6 class="counter" v-if="props.areaFlag == true"><VueJsCounter   :end="members"  duration="10000" thousand=""></VueJsCounter></h6>
						
					</div>
					<div class="col-md-6 w3l_schedule_bottom_right_grid1">
						<i class="fa fa-calendar-o" aria-hidden="true"></i>
						<h4>تراکنش های موفق</h4>
						<h6 class="counter" v-if="props.areaFlag == true"><VueJsCounter :end="events"  duration="10000" thousand=""></VueJsCounter></h6>
					</div>
				
				</div>
				<p class="text-center"> اطلاع از جوایز و تخفیف های ویژه در کانال های زیر
				</p>
				<div class="d-flex justify-content-center">
					<div class="card" style="width: 7rem;border:none">
						<a class="text-link text-center" href="https://t.me/onlin_radap" >
							<img src="https://radap.ir/imagesUploaded/social/telegram.jpg" class="card-img-top " style="width:3em" alt="...">
							<div class="card-body p-0">
								<h5 class="card-title text-center">تلگرام</h5>
							</div>
						</a>
					</div>
					<div class="card" style="width: 7rem;border:none">
						<a class="text-danger text-center" href="https://rubika.ir/RAADAPP">
							<img src="https://radap.ir/imagesUploaded/social/rubika.jpg" class="card-img-top " style="width:3em" alt="...">
								<div class="card-body p-0">
									<h5 class="card-title text-center">روبیکا</h5>
								</div>
						</a>
					</div>

				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script setup>
import VueJsCounter from 'vue-js-counter'
import axios from 'axios';
import {ref,defineProps} from 'vue';
let members = ref(0);
let events = ref(0);
let rewards = ref(200);
let props = defineProps(['areaFlag'])
getCounter();
function getCounter(){
    axios
    .get('https://radap.ir/Backend/api/section/pages/main/counter.php')
        .then((res)=>
        {
			members.value += parseInt(res.data.member)
			events.value = 2364 + parseInt(res.data.event);
			rewards.value = 200;
        })
}
// function PersianNumber(t){for(t=t.toString();t.search("0")>-1;)t=t.replace("0","۰");for(;t.search("1")>-1;)t=t.replace("1","۱");for(;t.search("2")>-1;)t=t.replace("2","۲");for(;t.search("3")>-1;)t=t.replace("3","۳");for(;t.search("4")>-1;)t=t.replace("4","۴");for(;t.search("5")>-1;)t=t.replace("5","۵");for(;t.search("6")>-1;)t=t.replace("6","۶");for(;t.search("7")>-1;)t=t.replace("7","۷");for(;t.search("8")>-1;)t=t.replace("8","۸");for(;t.search("9")>-1;)t=t.replace("9","۹");return t}
</script>

<style scoped>
.agileits_schedule_bottom_right{
	text-align: -webkit-center;
	padding: 1px !important;
}
.row {
    --bs-gutter-x: 0;
}
h6{
	font-weight: 900;
	font-size: 1.25rem !important;
}
p{
	letter-spacing: 0 !important;
}
@media (max-width: 768px){
.agileinfo_schedule_bottom_left {
	display: none !important;
}
}
</style>